import EventEmitter from 'eventemitter3'
import RankingManager from '../ranking/RankingManager'
import RankingView from '../ranking/RankingView'
import EnvUtil from '../util/EnvUtil'

/**
 * OverViewクラス
 */
class OverView extends EventEmitter{
  // ---------------------------------------------------------------------------------------------------------
  // --	OverView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super();
  }

  /**
   * 初期化
   */
  init()
  {
    //DOM参照
    this.container = $("#gameover");
    this.sendButton = this.container.find("a.sendbutton");
    this.retryButton = this.container.find("a.retrybutton");
    this.rankingButton = this.container.find("a.rankingbutton");
    this.tweetButton = this.container.find("a.tweetbutton");
    this.result = this.container.find("div.result");

    //ボタンアクション
    this.sendButton.on("click", (e) => {
      e.preventDefault();
      this.sendScore();
    });
    this.retryButton.on("click", (e) => {
      e.preventDefault();
      this.emit("retry");
    });
    this.rankingButton.on("click", (e) => {
      e.preventDefault();
      RankingView.open();
    });
    this.tweetButton.on("click", (e) => {
      e.preventDefault();
      this.emit("tweet", this.scoreStr);
    });

    //初期リセット
    this.reset();
  }

	/**
	* リセット
	**/
  reset()
  {
    //Tween停止
    TweenMax.killTweensOf(this.container);
  
    //初期非表示
    this.container.hide();
    
    //結果の文言変更
    this.result.text("---");
  }


	// --------------------------------------------------------------------------------------------------------------------------------------
	// --	 開く
	// --------------------------------------------------------------------------------------------------------------------------------------
	
	/**
	* 開く
	**/
  open(score, str = 'none')
  {
    //スコア保持
    this.score = score;

    //スコア表示
    if(str == 'none')
    {
      this.scoreStr = this.score;
    }
    else
    {
      this.scoreStr = str;
    }
    this.container.find("span.score-num").text(this.scoreStr);
    
    //フラグ
    this.sendedFlag = false;
    this.updateSendButton();
    
    //コンテナ表示
    this.container.show();
    TweenMax.set(this.container, {opacity:0});
    TweenMax.to(this.container, 0.3, {opacity:1, ease:Power0.easeNone, onComplete:() => {
      this.textCheckStart();
    }});
  }
    

  // --------------------------------------------------------------------------------------------------------------------------------------
	// --	 閉じる
	// --------------------------------------------------------------------------------------------------------------------------------------
	
	/**
	* 閉じる
	**/
  close()
  {
    //リセット
    this.reset();
    
    //テキストチェック停止
    this.textCheckStop();
  }
    

  // --------------------------------------------------------------------------------------------------------------------------------------
	// --	入力チェック
	// --------------------------------------------------------------------------------------------------------------------------------------
    
  /**
  * テキストチェック開始
  */
	textCheckStart()
	{
		//DOM の　input 要素
		const $inputElm = $('#name-input');
		
    // 文字列チェック用の正規表現
    const alloweStrings = /[^A-Za-z]+/;
         
    //KeyUpイベント
    $inputElm.on('keyup' , (e)=>
    {
      //Android端末以外は入力ごとにDOM input要素を更新
      if(EnvUtil.isAndroid)
      {
        this.updateDOMInput($inputElm,alloweStrings);
      }
      
      //実行キーが押された時は入力フィールドのフォーカスをはずす
      if(e.keyCode == 13)
      {
        $inputElm.blur();
      }
    });
         
    //入力フィールドのフォーカスがはずれた時にチェック
    $inputElm.on('blur' , (e)=>
    {
      this.updateDOMInput($inputElm, alloweStrings);
    });
  }
    
  /**
  * テキストチェック停止
  */
  textCheckStop()
  {
    //DOM の　input 要素
    const $inputElm = $('#name-input');
  
    //リスナー削除
    $inputElm.off("keyup");
    $inputElm.off("blur");
  }
    
  /**
  * DOM input要素のバリデーション
  */
  updateDOMInput($inputElm, alloweStrings)
  {
    //テキストのバリデーション
    const inputText = $inputElm.val();
    let text = inputText.replace(alloweStrings,"");
    text = text.toUpperCase();

    // 置換する
    if(text !== inputText)
    {
      $inputElm.val(text);
    }

    //送信ボタン表示更新
    this.updateSendButton();
  }
  
  /**
   * 送信ボタンの表示更新
   */
  updateSendButton()
  {
    if(this.sendedFlag)
    {
      return;
    }
    
		//DOM の　input 要素
		const $inputElm = $('#name-input');
		
    // 文字列チェック用の正規表現
    const alloweStrings = /[^A-Za-z]+/;
         
    //OKボタンのステータス変更
    const inputText = $inputElm.val();
    const text = inputText.replace(alloweStrings,"");
    if(text !== "")
    {
			this.sendButton.removeClass("non-active");
    }
    else
    {
			this.sendButton.addClass("non-active");
    }
  }
    
    
	// --------------------------------------------------------------------------------------------------------------------------------------
	// --	スコア送信
	// --------------------------------------------------------------------------------------------------------------------------------------
    
  sendScore()
  {
		//DOM の　input 要素
		const $inputElm = $('#name-input');
		
    // 文字列チェック用の正規表現
    const alloweStrings = /[^A-Za-z]+/;
    
    const inputText = $inputElm.val();
    let text = inputText.replace(alloweStrings,"");
    if(text !== "")
    {
      RankingManager.on("send-success", this.onSuccess.bind(this));
      RankingManager.on("send-error", this.onError.bind(this));
      RankingManager.sendScore(text, this.score);
    }
    
    this.sendedFlag = true;
    this.sendButton.addClass("non-active");
  }
    
  onSuccess()
  {
    RankingManager.off("send-success");
    RankingManager.off("send-error");
      
    //結果の文言変更
    this.result.text("送信しました！");
  }
    
  onError()
  {
    RankingManager.off("send-success");
    RankingManager.off("send-error");
        
    alert("スコアを送信できませんでした。");
    
    this.sendedFlag = false;
    this.sendButton.removeClass("non-active");
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default new OverView()
